let scrollPos = 0;
const scrollPosSticky = 1;
const scrollPosHidden = 800;
const body = document.querySelector('body');
const scrollSpy = document.getElementById('scrollspy');
const scrollSpySticky = document.getElementById('scrollspybar');

function checkPosition() {
    var ProductMenu = document.getElementById('c-productmenu');

    if (ProductMenu === null) {
        const windowY = window.scrollY;

        if (windowY < scrollPosSticky) {
            body.classList.remove('is-sticky');
        } else {
            body.classList.add('is-sticky');
        }

        if (windowY < scrollPosHidden) {
            body.classList.remove('is-hidden');
        } else {
            body.classList.add('is-hidden');
        }

        if (windowY < scrollPos) {
            body.classList.remove('is-hidden');
        }

        scrollPos = windowY;
    } else {
        const windowY = window.scrollY;

        if (windowY < scrollPosSticky) {
            body.classList.remove('is-sticky');
        } else {
            body.classList.add('is-sticky');
        }

        if (windowY < scrollPosHidden) {
            body.classList.remove('is-hidden');
        } else {
            body.classList.add('is-hidden');
        }

        scrollPos = windowY;
    }

    if (scrollSpy != null) {
        if (scrollSpy.getBoundingClientRect().top < 0) {
            scrollSpySticky.classList.add('sticky');
        }

        if (scrollSpy.getBoundingClientRect().top > 0) {
            scrollSpySticky.classList.remove('sticky');
        }
    }
}

checkPosition();
window.addEventListener('scroll', checkPosition);
